import { useModalStore } from '@/features/UserInterface/stores/modal';

export const FREE_GIFT_MODAL_ID = 'free-gift-select';

let resolvePendingPrompt: ((displaySku: string | null) => void) | null = null;

export const resolveFreeGiftPrompt = (displaySku: string | null) => {
  const resolvePrompt = resolvePendingPrompt;
  resolvePendingPrompt = null;
  resolvePrompt?.(displaySku);
};

export const promptFreeGift = (): Promise<string | null> => {
  resolveFreeGiftPrompt(null);
  return new Promise((resolve) => {
    resolvePendingPrompt = resolve;
    useModalStore().openModal(FREE_GIFT_MODAL_ID);
  });
};
